var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2916 12.7166L12.6833 21.3249M10.3058 9.4063H16.3028M19.3913 4.57297C18.9896 3.09083 17.6276 2 16.0092 2H6.34783C3.94659 2 2 3.94659 2 6.34783V15.6048C2 17.2984 3.11596 18.733 4.65703 19.2222M8.40316 4.6087C6.30754 4.6087 4.6087 6.30754 4.6087 8.40316V18.2055C4.6087 20.3012 6.30754 22 8.40316 22H11.0909C12.3134 22 13.3043 21.009 13.3043 19.7866V16.4664C13.3043 14.72 14.72 13.3043 16.4664 13.3043H19.7866C21.009 13.3043 22 12.3134 22 11.0909V8.40316C22 6.30754 20.3012 4.6087 18.2055 4.6087H8.40316Z",
    stroke: "currentColor",
    strokeWidth: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.b689ae3f792154924fc37bb6de5d49c4.svg";
export { ForwardRef as ReactComponent };